import * as actionTypes from './action-types';
import { defineAction } from 'store/common/action-helpers';

export const setInterests = {
  request: (values, userId, { form, wizard }) =>
    defineAction(actionTypes.SET_USER_INTERESTS.REQUEST, { values, userId }, { form, wizard }),
  start: values => defineAction(actionTypes.SET_USER_INTERESTS.START, values),
  success: response => defineAction(actionTypes.SET_USER_INTERESTS.SUCCESS, response),
  failure: error => defineAction(actionTypes.SET_USER_INTERESTS.FAILURE, error),
};
